export const SIDE_FILTERS_ENUM = {
  'All Emails': '1',
  Unassigned: '2',
  'Assigned to me': '3',
  Inbox: '4',
  Sent: '5',
  'Contact Form': '6',
  'Get Accept': '7',
  B2B: '8',
  'Buy Contact Form': '9',
  BoxNow: '10',
  'Delivery Failures': '11',
  Automated: '12',
};
